/**
 * Submit guard for appointment forms that require a committed, validated slot selection.
 */

import type { SlotUnavailableViolation } from '../create-appointment/types';

/**
 * Returns whether the user should be blocked from submitting an appointment slot form.
 * @returns `true` when no time is committed, the slot conflicts, results are truncated, or slots are still loading.
 */
export function isAppointmentSlotSubmitDisabled({
  hasCommittedStartTime,
  slotUnavailable,
  truncated,
  isCheckingSelectedMonthSlots
}: {
  /** Whether the user chose a concrete start time rather than only a calendar day. */
  hasCommittedStartTime: boolean;
  /** Active unavailable-slot violation, if any. */
  slotUnavailable: SlotUnavailableViolation | null;
  /** Whether the availability response was truncated before all slots were returned. */
  truncated: boolean;
  /** Whether slot data for the selected month is still being refreshed. */
  isCheckingSelectedMonthSlots: boolean;
}): boolean {
  return (
    !hasCommittedStartTime
    || slotUnavailable?.hasViolation === true
    || truncated
    || isCheckingSelectedMonthSlots
  );
}
